import { gql } from "@apollo/client";
export default gql`
  query CheckUserLoginType($username: String!) {
    checkUserLoginType(username: $username) {
      isSso
      cognitoDisabled
      identityProvider
      cognitoClientId
      cognitoDomain
    }
  }
`;
